if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaModalSwiper = null;
        this.initModalSwiper();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }


      initModalSwiper() {
        const thumbsSwiper =  new Swiper('.product-media-modal__content .product-media-modal__slider-thumbnail', {
          slidesPerView: 'auto',
          spaceBetween: 20,
          freeMode: true,
        });

        this.mediaModalSwiper =  new Swiper('.product-media-modal__content .product-media-modal__slider', {
          slidesPerView: 'auto',
          spaceBetween: 20,
          loop: true,
          freeMode: false,
          thumbs: {
            swiper: thumbsSwiper
          },
          navigation: {
            nextEl: ".product-media-modal__next",
            prevEl: ".product-media-modal__prev",
          }
        });
      }

      showActiveMedia() {
        const index = +this.openedBy.dataset.mediaIndex - 1;
        this.mediaModalSwiper.slideTo(index);
       /* this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();*/
      }
    }
  );
}
